module.exports = __webpack_public_path__ + "static/img/homezdsys.0b6c515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homezdsys.png
// module id = vbkw
// module chunks = 78